import { tsrClient } from '@/libs/ts-rest/ts-client';
import { createGetCollectionBySlugQueryOption } from '@/modules/products/react-query';

export const useGetCollectionBySlugQuery = (collectionSlug: string) => {
	const queryOptions = createGetCollectionBySlugQueryOption(collectionSlug);
	const collectionQueryResult = tsrClient.web.collections.getBySlug.useQuery(queryOptions);

	return collectionQueryResult;
};